'use strict';

import PressResponder from './PressResponder';
import { useDebugValue, useEffect, useRef } from 'react';
export default function usePressEvents(hostRef, config) {
  var pressResponderRef = useRef(null);

  if (pressResponderRef.current == null) {
    pressResponderRef.current = new PressResponder(config);
  }

  var pressResponder = pressResponderRef.current;
  useEffect(function () {
    pressResponder.configure(config);
  }, [config, pressResponder]);
  useEffect(function () {
    return function () {
      pressResponder.reset();
    };
  }, [pressResponder]);
  useDebugValue(config);
  return pressResponder.getEventHandlers();
}